// ============================================================================
// ENGLISH TRANSLATIONS - BIBLE TREASURES
// ============================================================================
// Spiritual treasures and pearls of biblical wisdom

export const bibleTreasures = [
  {
    type: "wisdom_pearl",
    content: "He who walks with wise men will be wise, but the companion of fools will be destroyed",
    reference: "Proverbs 13:20",
    category: "wisdom",
    strongNumbers: {
      "wise": "H2450", // חכם (chakam) = wise, intelligent
      "walks": "H1980" // הלך (halak) = to walk, live
    },
    reflection: "The importance of choosing our companions and mentors wisely"
  },
  {
    type: "divine_treasure",
    content: "The Lord is near to those who have a broken heart, and saves such as have a contrite spirit",
    reference: "Psalm 34:18",
    category: "comfort",
    strongNumbers: {
      "near": "H7138", // קרוב (qarob) = near, close
      "broken_heart": "H7665" // שבר (shabar) = to break, destroy
    },
    reflection: "God is especially close to those who suffer"
  },
  {
    type: "divine_promise",
    content: "For My thoughts are not your thoughts, nor are your ways My ways, says the Lord",
    reference: "Isaiah 55:8",
    category: "divine_mystery",
    strongNumbers: {
      "thoughts": "H4284", // מחשבה (machashebah) = thought, plan
      "ways": "H1870" // דרך (derek) = way, path
    },
    reflection: "Divine wisdom surpasses our human understanding"
  },
  {
    type: "encouragement",
    content: "Be strong and of good courage; do not be afraid, nor be dismayed, for the Lord your God is with you",
    reference: "Joshua 1:9",
    category: "courage",
    strongNumbers: {
      "strong": "H2388", // חזק (chazaq) = to be strong, hold fast
      "courage": "H553" // אמץ (amats) = to be courageous
    },
    reflection: "Courage comes from God's constant presence"
  },
  {
    type: "faith_mystery",
    content: "Now faith is the substance of things hoped for, the evidence of things not seen",
    reference: "Hebrews 11:1",
    category: "faith",
    strongNumbers: {
      "faith": "G4102", // πίστις (pistis) = faith, trust
      "substance": "G5287" // ὑπόστασις (hypostasis) = substance, assurance
    },
    reflection: "Faith transcends the visible and makes the invisible real"
  },
  {
    type: "revelation",
    content: "But whoever drinks of the water that I shall give him will never thirst",
    reference: "John 4:14",
    category: "spiritual_life",
    strongNumbers: {
      "water": "G5204", // ὕδωρ (hydor) = water
      "thirst": "G1372" // διψάω (dipsao) = to thirst
    },
    reflection: "Jesus offers eternal spiritual satisfaction"
  },
  {
    type: "divine_heritage",
    content: "Now if we are children, then we are heirs—heirs of God and co-heirs with Christ",
    reference: "Romans 8:17",
    category: "identity",
    strongNumbers: {
      "heirs": "G2818", // κληρονόμος (kleronomos) = heir
      "children": "G5043" // τέκνον (teknon) = child, descendant
    },
    reflection: "Our divine identity as children and heirs of God"
  }
];

export default bibleTreasures;